import Axios from 'axios';

const state = {
  crud: [],
  dialog: false,
  editedIndex: -1,
  editedItem: {},
  snackBarText: '',
  snackBar: false,
  snackBarColor: 'primary',
  module: '',
};
const getters = {
  DIALOG: state => state.dialog,
  EDITED_INDEX: state => state.editedIndex,
  EDITED_ITEM: state => state.editedItem,
};
const mutations = {
  SET_DIALOG: (state, payload) => {
    state.dialog = payload;
  },
  SET_MODULE: (state, payload) => {
    state.module = payload;
  },
  SET_SNACKBARTEXT: (state, payload) => {
    state.snackBarText = payload;
  },
  SET_SNACKBARCOLOR: (state, payload) => {
    state.snackBarColor = payload;
  },
  SET_SNACKBAR: (state, payload) => {
    state.snackBar = payload;
  },
  SET_INDEX: (state, payload) => {
    state.editedIndex = payload;
  },
  SET_ITEM: (state, payload) => {
    state.editedItem = payload;
  },
  SET_SUBITEM: (state, payload) => {
    state.editedItem[payload.name] = payload.value;
  },
};
const actions = {
  LOAD_DIALOG: (context) => {
    context.commit('SET_DIALOG', true);
  },
  SET_MODULE: (context, payload) => {
    context.commit('SET_MODULE', payload);
  },
  UNLOAD_DIALOG: (context) => {
    context.commit('SET_DIALOG', false);
  },
  SET_INDEX: (context, payload) => {
    context.commit('SET_INDEX', payload);
  },
  SET_ITEM: (context, payload) => {
    context.commit('SET_ITEM', payload);
  },
  SET_SUBITEM: (context, payload) => {
    if (context.state.editedItem.length && context.state.editedItem[payload.name].length) {
      context.commit('SET_SUBITEM', payload);
    }
  },

  SET_SNACKBAR: (context, payload) => {
    console.log('sneeeeek');
    context.commit('SET_SNACKBAR', payload);
  },
  SET_SNACKBAR_ERROR: (context, payload) => {
    console.log('sneeeeek');

    context.commit('SET_SNACKBARTEXT', payload);
    context.commit('SET_SNACKBARCOLOR', 'red');
    context.commit('SET_SNACKBAR', true);
  },
  RESET_SNACKBAR: (context, payload) => {
    console.log('sneeeeek');
    context.commit('SET_SNACKBAR', false);
    context.commit('SET_SNACKBARTEXT', '');
    context.commit('SET_SNACKBARCOLOR', 'primary');
  },
  SET_SNACKBARTEXT: (context, payload) => {
    context.commit('SET_SNACKBARTEXT', payload);
  },
  SET_SNACKBARCOLOR: (context, payload) => {
    context.commit('SET_SNACKBARCOLOR', payload);
  },

};
export default {
  state,
  getters,
  mutations,
  actions,
};
